import * as moment from 'moment'
import { isMobileOnly, isTablet } from 'react-device-detect'

export const getLastWordFromString = (s: string) => {
  const lastSpace = s.lastIndexOf(' ')
  return {
    rest: s.substring(0, lastSpace),
    last: s.substring(lastSpace + 1, s.length)
  }
}
export const getParamFromUrl = (url: string, key: string): string => {
  const index = url.indexOf(key)
  if (index < 0) {
    return ''
  }
  const delim = url.indexOf('&', index)
  const start = index + key.length + 1
  const end = delim < 0 ? url.length : delim
  if (start > end) {
    return ''
  }
  return url.substring(start, end)
}

export const getIfLinkExist = <T = string, F = undefined>(
  link: string,
  onTrue: T,
  onFalse: F
): T | F => (link && link !== '#' ? onTrue : onFalse)
export const getFirstKey = (obj: object) => (obj && Object.keys(obj)[0]) || ''

export const getPercentile = (value: number, maxValue: number = 1) =>
  (value / maxValue) * 100

export const objectsEqual = (obj1: object, obj2: object) => {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false
  }
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)
  if (keys1.length !== keys2.length) {
    return false
  }
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false
    }
  }
  return true
}

export const copyToClipboard = (text: string) => {
  const input = document.createElement('textarea')
  input.innerHTML = text
  input.style.width = '0'
  input.style.height = '0'
  document.body.appendChild(input)
  input.select()
  const result = document.execCommand('copy')
  document.body.removeChild(input)
  return result
}

export function modalDeviceType() {
  switch (true) {
    case isMobileOnly:
      return 'isMobile'

    case isTablet:
      return 'isTablet'

    default:
      return ''
  }
}

export const childDashboardNameTransform = (name: string): string => {
  const nameWithUppercase =
    name.charAt(0).toLocaleUpperCase() + name.substring(1)
  const lastChar = name.charAt(name.length - 1)

  return lastChar === 's'
    ? `${nameWithUppercase}' Dashboard`
    : `${nameWithUppercase}'s Dashboard`
}

export const getAge = (birthDate: number, lockedDate?: number): number => {
  const birthday = moment(birthDate * 1000).format('YYYY-MM-DD')
  if (lockedDate) {
    return moment(lockedDate * 1000).diff(birthday, 'years')
  }

  return moment().diff(birthday, 'years')
}

const isLog = process.env.REACT_APP_IS_PROD !== 'true'
export const logger = {
  info: (message: string, ...attrs: any[]) => {
    if (isLog) {
      console.log(`%c${message}`, 'color: lightblue', ...attrs)
    }
  }
}

export default {
  getLastWordFromString,
  getParamFromUrl,
  getIfLinkExist,
  getFirstKey,
  getPercentile,
  objectsEqual,
  copyToClipboard,
  modalDeviceType,
  childDashboardNameTransform
}



// WEBPACK FOOTER //
// ./src/services/utils.ts